import { render, staticRenderFns } from "./ModelingCard.vue?vue&type=template&id=18cfd48c"
import script from "./ModelingCard.vue?vue&type=script&lang=js"
export * from "./ModelingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports